// src/components/Auth/LandingRedirect.jsx
import React, { useContext } from 'react'
import { Navigate } from 'react-router-dom'
import { AuthContext } from '../../contexts/AuthContext'
import { getFirstAllowedRoute } from '../Utils/firstAllowedRoute'
import Loader from '../Utils/Loader'

export default function LandingRedirect() {
  const { ready, user, hasPermission } = useContext(AuthContext)

  if (!ready) return <Loader />
  if (!user) return <Navigate to="/login" replace />

  const dest = getFirstAllowedRoute(hasPermission)
  return <Navigate to={dest} replace />
}
